<template>
    <div class="fluid fill-height fill-width" style="width: 100%;flex: 1 1 auto;position: relative;">
        <div ref="tiffContainer" style="right: 0px;height: 100%;" class="tiff-container" v-bind:style="{right: (fullWidth) ? '0' : '500px'}"></div>
    </div>
</template>

<script>

    import ExternalLoader from '@/lib/external-loader'
    import FilesRepository from '@/repositories/FilesRepository';

    export default {
        name: 'TiffViewer',
        mounted() {
            // load Resources
            let loader = new ExternalLoader(document);
            let resources = ["/vendor/image/tiff.min.js"];
            loader.load(resources).then(() => { this.loaded = true });
            this.$root.$emit('show-register-ad');
        },
        props: {
            fullWidth: Boolean,
            hash: String,
            token: String,
            email: String
        },
        data () {
            return {
                loaded: false,
            }
        },
        watch: {
            loaded: function () {
                this.load();
            },
            hash: function () {
                this.load();
            }
        },
        methods: {

            load() {
                if (this.hash && this.loaded) {
                    FilesRepository.getFile(this.hash, this.token)
                        .then((response) => {
                            this.loadTiff(response.data);
                            this.finished();
                        })
                        .catch((error) => {
                            this.error(error);
                        })
                }
            },

            loadTiff(data) {
                var tiff = new Tiff({buffer: data});
                var tiffcanvas = tiff.toCanvas();
                tiffcanvas.style['position'] = "relative";
                tiffcanvas.style['max-width'] = "100%";
                tiffcanvas.style['max-height'] = "100%";
                this.$refs.tiffContainer.append(tiffcanvas);
                this.$refs.tiffContainer.oncontextmenu = () => false;
                this.$refs.tiffContainer.oncanvas = () => false;
            },

            error(error) {
                this.$emit('error', error);
            },

            finished() {
                this.$emit('loaded');
            }

        }
    };
</script>

<style scoped>
    .tiff-container {
        left: 0;
        top: 0;
        bottom: 0;
        position: absolute;
    }
</style>